import vAutosuggest from './Autosuggest';

export { vAutosuggest };


// WEBPACK FOOTER //
// ./src/baseComponents/components/Autosuggest/index.js